import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Map as MapIcon } from 'lucide-react';
import { AuthContext } from '../../contexts/AuthContext';
import PageHeader from './PageHeader';

const Sitemap = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const isDev = process.env.NODE_ENV === 'development';

  // Pages that can be opened directly (no study, site or participant in the
  // address). Kept in step with routes.jsx (FECOA-2175).
  const routes = [
    { path: "/", name: "Home", group: "General" },
    { path: "/login", name: "Login", group: "Authentication" },
    { path: "/forgot-password", name: "Forgot Password", group: "Authentication" },
    { path: "/mfa/recovery/request", name: "MFA Recovery", group: "Authentication" },
    { path: "/caregiver-login", name: "Caregiver Sign In", group: "Authentication" },
    { path: "/studies", name: "Studies", group: "Studies" },
    { path: "/create-new-study", name: "Create New Study", group: "Studies" },
    { path: "/studybuilder", name: "Study Builder", group: "Studies" },
    { path: "/studybuilder/create", name: "Create Study Draft", group: "Studies" },
    { path: "/studybuilder/drafts", name: "Study Drafts", group: "Studies" },
    { path: "/study-promotion", name: "Study Promotion", group: "Studies" },
    { path: "/assessment-builder", name: "Assessment Builder", group: "Assessments" },
    { path: "/assessment-builder/review-queue", name: "Review Queue", group: "Assessments" },
    { path: "/dcq/", name: "DCQs", group: "Data Collection" },
    { path: "/notifications", name: "Notifications", group: "User" },
    { path: "/profile", name: "Profile", group: "User" },
    { path: "/change-password", name: "Change Password", group: "User" },
    { path: "/api-key", name: "API Keys", group: "User" },
    { path: "/faq", name: "FAQ", group: "User" },
    { path: "/sponsor-selector", name: "Sponsor Selector", group: "Administration" },
    { path: "/superadmin", name: "SuperAdmin Panel", group: "Administration" },
    { path: "/user-management", name: "User Management", group: "Administration" },
    { path: "/session-expired", name: "Session Expired", group: "Error" },
    ...(isDev ? [
      { path: "/sitemap", name: "Sitemap", group: "Development" },
      { path: "/development", name: "Development", group: "Development" }
    ] : []),
  ];

  const groupedRoutes = routes.reduce((acc, route) => {
    (acc[route.group] = acc[route.group] || []).push(route);
    return acc;
  }, {});

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <div>
        <PageHeader icon={MapIcon} title="Sitemap" />
        
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {Object.entries(groupedRoutes).map(([group, routes]) => (
            <motion.div
              key={group}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.25, ease: 'easeOut' }}
              className="card overflow-hidden"
            >
              <div className="card-band">
                <h2 className="card-band-title">{group}</h2>
              </div>
              <ul className="space-y-2 px-6 py-4">
                {routes.map((route, index) => (
                  <li key={index}>
                    <Link
                      to={route.path}
                      className="link text-sm"
                    >
                      {route.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Sitemap;